import { useState } from "react";
import Button from "@mui/material/Button";
import FilenameFormDialog from "./FilenameFormDialog";
import { projectDataPropType } from "../util/propTypeHelper";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFloppyDisk } from "@fortawesome/free-solid-svg-icons";

export default function ExportAnalysisButton({ projectData }) {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const isProjectDataEmpty = Object.keys(projectData).length === 0;
  const closeDialog = () => setIsDialogOpen(false);

  return (
    <>
      <Button
        variant="outlined"
        color="success"
        startIcon={
          <FontAwesomeIcon icon={faFloppyDisk} style={{ marginRight: "8px" }} />
        }
        style={{ margin: "20px" }}
        disabled={isProjectDataEmpty} //is green when enabled
        onClick={() => setIsDialogOpen(true)}
      >
        Export Analysis
      </Button>
      {isDialogOpen && (
        <FilenameFormDialog onClose={closeDialog} projectData={projectData} />
      )}
    </>
  );
}

ExportAnalysisButton.propTypes = {
  projectData: projectDataPropType.isRequired,
};
